<template>
  <div class="d-flex align-items-end flex-wrap gap-2">
    <div style="min-width: 320px; max-width: 480px">
      <custom-drop-down
        v-model="selectedJournal"
        fieldkey="paymentJournalId"
        fieldname="label"
        label="Seleccione Jornal de Pagos:"
        :options="journalOptions"
        placeholder="Seleccione"
      />
    </div>
    <div class="d-flex ml-2">
      <action-button
        i="fas fa-times-circle"
        variant="outline-danger px-3 mr-2"
        @click="$emit('on-cancel')"
      >
        Cancelar
      </action-button>
      <action-button
        :disabled="!selectedJournal"
        i="fas fa-arrow-right"
        variant="success px-3"
        @click="onConfirm"
      >
        Continuar
      </action-button>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';

export default {
  name: 'SelectJournalPayment',
  components: {
    CustomDropDown,
    ActionButton,
  },
  props: {
    journals: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedJournal: null,
    };
  },
  computed: {
    journalOptions() {
      return this.journals.map((j) => ({
        ...j,
        label: `Número de Jornal: ${j.paymentJournalNumber}  ${j.paymentJournalTypeName}`,
      }));
    },
  },
  watch: {
    journals: {
      immediate: true,
      handler(val) {
        this.selectedJournal = val.length === 1 ? this.journalOptions[0] : null;
      },
    },
  },
  methods: {
    onConfirm() {
      if (!this.selectedJournal) return;
      const id =
        typeof this.selectedJournal === 'object'
          ? this.selectedJournal.paymentJournalId
          : this.selectedJournal;
      this.$emit('on-confirm', id);
    },
  },
};
</script>
